module.exports = __webpack_public_path__ + "static/img/G2-SSRS.153093f8.png";